module.exports = __webpack_public_path__ + "static/img/wp_contact_3.db51a25.jpg";